<template>
    <sa-page-layout :btnBackVisible="false" :btnEditVisible="false" :btnRefreshVisible="false" :linkback="linkback" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <RsaPlanningComponent ref="cmpRsaPlanningComponent" @changeShowModalLoading="changeShowModalLoading"></RsaPlanningComponent>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaPlanningComponent from "../components/RsaPlanningComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { SaPageLayout, RsaPlanningComponent },
    mixins: [UtilityMixin],
    name: "RsaPlanningPage",
    data() {
        return {
            linkback: null,
            pathResource: "/rsaaree",
            showModalLoading: false,
            idUtente: null,
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.loadDataUser();
    },
    methods: {
        loadPresidi() {},
        onSubmit() {},
        onReset() {},
        changeShowModalLoading(value) {
            this.showModalLoading = value;
        },
        loadDataUser() {
            let me = this;
            me.loadDataResources("/users/profile", {}, me.resultResponseUser, null);
        },
        resultResponseUser(response) {
            let me = this;
            me.idUtente = response.data.data.id;
            me.$refs.cmpRsaPlanningComponent.init(me.idUtente);
        },
    },
};
</script>

<style scoped></style>
